export default {
    SET_OBJECT_NAME: 'SET_OBJECT_NAME',
    SET_CREATION_MODE: 'SET_CREATION_MODE',
    SET_SUMMARY_STATUS: 'SET_SUMMARY_STATUS',
    SET_ACTIONS_STATUS: 'SET_ACTIONS_STATUS',
    SET_PROPERTIES_STATUS: 'SET_PROPERTIES_STATUS',
    SET_SETBACKEDIT_STATUS: 'SET_SETBACKEDIT_STATUS',
    SET_INVERTER_DROPDOWN_STATUS: 'SET_INVERTER_DROPDOWN_STATUS',
};
